import { Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';

import { themeColors } from '@/config/theme/themeColors.ts';
import { DeltaEmailBasicUpdate } from '@/models/BasicEmail.model.ts';
import { EMAILS_REDUCER_EVENT } from '@/views/emails/context/EmailsContext.ts';
import { EmailsReducerAction } from '@/views/emails/context/EmailsContextProvider.tsx';

interface Props {
  mail: DeltaEmailBasicUpdate;
  onGoToEmails: () => void;
  updateEmailState: (value: EmailsReducerAction) => void;
}

export const NewMailToast: React.FC<Props> = props => {
  const { mail, onGoToEmails, updateEmailState } = props;
  const { emailThreadId, externalEmailId, userFolderId } = mail.email;

  const handleGoToEmail = () => {
    updateEmailState({
      payload: { folderId: userFolderId },
      type: EMAILS_REDUCER_EVENT.SELECT_BOX,
    });
    if (emailThreadId.value?.value) {
      updateEmailState({
        payload: {
          selectedEmail: externalEmailId.value,
          selectedThread: emailThreadId.value.value,
        },
        type: EMAILS_REDUCER_EVENT.SELECT_THREAD,
      });
    }
    onGoToEmails();
  };

  return (
    <Stack
      onClick={handleGoToEmail}
      sx={{ borderLeft: `3px solid ${themeColors.accentColor}`, cursor: 'pointer', pl: 1 }}
    >
      <Typography variant="f14Medium">{mail.email.from.value?.value ?? ''}</Typography>
      <Typography sx={{ color: themeColors.accentColor }} variant="f14Regular">
        {mail.email.subject.value ?? ''}
      </Typography>
      <Typography variant="f14Regular">{mail.email.bodyPreview.value?.substring(0, 30)}</Typography>
    </Stack>
  );
};
